module.exports = __webpack_public_path__ + "images/navigation/silver-device@3x-888b3b66.jpg";